import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environments } from '../../../../environments/environment';
import { FacturaContentModel, FacturaModel } from "src/app/domain/models/factura/factura.model";
import { FacturaGateway } from "src/app/domain/models/factura/gateways/factura.gateway";
import { FacturaCambioEstadoModel } from "src/app/domain/models/factura/factura-cambio-estado.model";


@Injectable({
    providedIn: 'root'
})
export class FacturaAdapter extends FacturaGateway {
    
    _back_url_base: string;
    _factura_findall_url_service: string;
    _factura_export_url_service: string;
    _factura_get_url_service: string;
    _numero: string = '';
    _ciudad: string = '';
    _nit: string = '';
    _estado: string = '';

    constructor(private http: HttpClient) {
        super();
        this._back_url_base = environments.BACK_URL_BASE;
        this._factura_findall_url_service = environments.FACTURA_FINDALL_URL_SERVICE;
        this._factura_export_url_service = environments.FACTURA_EXPORT_URL_SERVICE;
        this._factura_get_url_service = environments.FACTURA_GET_URL_SERVICE;
    }

    resetParameters(): void {
        this._numero = '';
        this._ciudad = '';
        this._nit = '';
        this._estado = '';
    }

    buildOptions(option: string, data: string): void {
        if (data !== '') {
            switch (option) {
                case 'numerofactura':
                    this._numero = `&numero=${data}`;
                    break;
                case 'nit':
                    this._nit = `&nit=${data}`;
                    break;
                case 'ciudad':
                    this._ciudad = `&ciudadentrega=${data}`;
                    break;
                //case 'estado':
                //    this._estado = `&estado=${data}`;
                //    break;
            }
        }
    }

    findAll(page?: number, size?: number, data: string = '', option?: string, estado?: string): Observable<FacturaModel> {
        let pageProcess: string = page == undefined ? '' : `&page=${page}`;
        let sizeProcess: string = size == undefined ? '' : `&size=${size}`;

        this._estado = (estado == undefined || estado == '') ? '' : `&estado=${estado}`;

        this.buildOptions(option!, data);
        
        const url = `${this._back_url_base}${this._factura_findall_url_service}?${pageProcess}${sizeProcess}${this._numero}${this._nit}${this._ciudad}${this._estado}`;
        this.resetParameters();
        return this.http.get<FacturaModel>(
            url
        );
    }

    export(data?: string, option?: string): Observable<HttpResponse<Blob>> {
        this.buildOptions(option!, data!);

        const url = `${this._back_url_base}${this._factura_export_url_service}?${this._numero}${this._nit}${this._ciudad}`;
        this.resetParameters();
        return this.http.get(
            url,
            {
                responseType: 'blob',
                observe: 'response'
            }
        );
    }

    findByNumero(data: string): Observable<FacturaContentModel> {
        const url = `${this._back_url_base}${this._factura_get_url_service}/${data}`;
        this.resetParameters();
        return this.http.get<FacturaContentModel>(
            url
        );
    }

    cambiarEstado(facturaCambioEstadoModel: FacturaCambioEstadoModel): Observable<FacturaContentModel> {
        const url = `${this._back_url_base}api/factura`;
        return this.http.put<FacturaContentModel>(
            url,
            facturaCambioEstadoModel
        );
    }
}